<template>
  <div class="uuid" :class="{ 'is-alias': !!aliasUuid }">
    <template v-if="!!aliasUuid">
      <img class="tag" src="./images/uuid.jpg" alt="" />
      <span>{{ uuid }}</span>
    </template>
    <span v-else>{{ uuid }}</span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Uuid',
  props: {
    userUuid: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapGetters(['aliasList']),
    aliasUuid() {
      if(this.userUuid === '1000469') {
        return '88888'
      }
      if (this.aliasList) {
        const user = this.aliasList.find(item => {
          return item.userUuid === this.userUuid;
        });
        if (user) {
          return user.alias;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    uuid() {
      if (this.aliasUuid) {
        return this.aliasUuid;
      } else {
        return this.userUuid;
      }
    }
  },
  methods: {
    copyUuid() {
      navigator.clipboard.writeText(this.uuid);
      this.$message.success('複製成功');
    }
  },
  created() {
    if (!this.aliasList) {
      this.$store.dispatch('app/setAliasList');
    }
  }
};
</script>
<style lang="scss" scoped>
$height: 40px;
.uuid {
  display: inline-flex;
  &.is-alias {
    position: relative;
    .tag {
      height: $height;
      width: auto;
    }
    span {
      position: absolute;
      z-index: 1;
      left: 50px;
      top: 0;
      height: $height;
      line-height: 38px;
      color: white;
    }
  }
}
</style>
